"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderToEmailObject = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderCurrency_1 = require("./getOrderCurrency");
const getOrderLinesToJSON_1 = require("./getOrderLinesToJSON");
const getOrderLineToEmailObject_1 = require("./getOrderLineToEmailObject");
const getOrderToEmailObject = (order, order_line_id, exchange_rates) => {
    const currency = (0, getOrderCurrency_1.getOrderCurrency)(order);
    const exchange_rate = exchange_rates.find((x) => x.currency === order.client.display_currency &&
        x.base_currency === currency);
    if (!exchange_rate)
        return null;
    const itinerary = (0, getOrderLinesToJSON_1.getOrderLinesToJSON)(order, order.id, exchange_rate, undefined, true, false);
    if (!itinerary)
        return null;
    let response_obj = {
        agent: {
            id: order.agent.id,
            name: order.agent.name,
            logo: `https://golfsavers.b-cdn.net${order.agent.config.email.logo
                ? JSON.parse(order.agent.config.email.logo).url
                : "/assets/images/golfsaver_email_logo.png?height=80&quality=10"}`,
            email: order.agent.config?.email?.contact_email || "support@golfsavers.com",
            phone: order.agent.config?.email?.contact_phone || "+66 (0) 88 867 2867",
        },
        client: order.client,
        order: {
            id: order.id,
            itinerary: order_line_id ? null : itinerary.itinerary,
            reference: order.reference,
            currency: currency,
            display_currency: order.display_currency,
            has_alt_currency: order.display_currency !== currency,
        },
    };
    if (order_line_id) {
        const order_line = order.order_lines.find((x) => x.id === order_line_id);
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
        const linked_order_line = latest_version?.linked_line_id
            ? order.order_lines.find((x) => x.id === latest_version?.linked_line_id)
            : null;
        if (linked_order_line) {
            console.log(`LINKED ORDER LINE: ${JSON.stringify(linked_order_line, null, 2)}`);
        }
        response_obj = {
            order_line: (0, getOrderLineToEmailObject_1.getOrderLineToEmailObject)(order_line, linked_order_line),
            supplier: {
                id: latest_version?.supplier_id,
            },
            ...response_obj,
        };
    }
    return response_obj;
};
exports.getOrderToEmailObject = getOrderToEmailObject;
